<template>
  <div class="bg-background-primary">
    <div v-if="userStore.isLoading" class="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner color="primary" />
    </div>

    <NetworkError v-else-if="userStore.hasNetworkError" class="h-screen w-screen" />

    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";

import LoadingSpinner from "./components/LoadingSpinner.vue";
import NetworkError from "./components/NetworkError.vue";
import { useTheme } from "./composables/useTheme";
import { useBreakpointStore } from "./store/breakpoint";
import { useUserStore } from "./store/user";

const userStore = useUserStore();

const { loadTheme } = useTheme();
const { startScreenSizeListener } = useBreakpointStore();

onMounted(() => {
  loadTheme();
  startScreenSizeListener();
});
</script>

<style lang="scss">
.v-popper {
  &__inner {
    background: #fff !important;
    border: 2px solid #f5f7f8 !important;
    border-radius: 1rem !important;
    padding: 1.5rem !important;
    color: #5b6770 !important;
  }

  &__arrow-container {
    display: none !important;
  }
}
</style>
